// Escape handling for a dialog opened INSIDE a modal that already listens for
// Escape on `document`.
//
// THE PROBLEM. Modals in this codebase dismiss themselves from an unconditional
// document-level keydown listener — CampsPage.js's registrations modal is one
// (`setRegsCamp(null)` for as long as it is open), and ConfirmModal.js installs
// another for its own `onCancel`. Neither calls stopPropagation. So a dialog
// stacked inside a modal gets BOTH handlers on a single keypress: Escape
// dismisses the dialog and tears down the modal underneath it, discarding
// whatever that modal held. `window.confirm` never had this failure mode
// because it blocks the JS event loop — no keydown reaches any listener while
// it is up.
//
// THE FIX. A CAPTURE-phase listener on `document` runs during the capture
// phase, which reaches `document` BEFORE the event ever gets to its target and
// long before it bubbles back; stopPropagation() there ends the dispatch, so no
// bubble-phase listener on `document` — the modal's, or the dialog's own — is
// ever called. That is the whole point: the layer below must not see the key.
//
// The corollary is that this handler owns the dismissal. The dialog's own
// Escape handler will not run either, so `onEscape` has to do what that handler
// would have done.
//
// Install it only while the dialog is open, and tear it down with the returned
// function — a guard left installed swallows Escape for the whole page.
export function installEscapeGuard(onEscape, target = document) {
  const handler = (event) => {
    if (event.key !== 'Escape') return;
    event.stopPropagation();
    onEscape(event);
  };
  target.addEventListener('keydown', handler, true);
  return () => target.removeEventListener('keydown', handler, true);
}
